import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { Location } from "@angular/common";
import { SearchComponent } from "src/app/shared/components/search/search.component";
import { Router } from "@angular/router";
import { PopupService } from "../../popup/popup.service";
import { TranslationModuleEnum } from "src/app/utils/translation-modules.enum";

@Component({
  selector: "app-header-page",
  templateUrl: "./header-page.component.html",
  styleUrls: ["./header-page.component.scss"],
})
export class HeaderPageComponent implements OnInit {
  translationModulesEnum = TranslationModuleEnum;
  isOpenPopUp = false;
  isOpenImportPopUp = false;

  @ViewChild("search") searchComponent: SearchComponent;

  @Input() title: string = "";
  @Input() titleBtn: string = "";
  @Input() isSearch: boolean = false;
  @Input() searchKey: string = "";
  @Input() hasAdvancedFilter: boolean = false;

  @Input() isAddBtn: boolean = this.titleBtn ? true : false;
  @Input() showButtons = true;
  @Input() backButton = false;
  @Input() isStartServiseTitle = false;
  @Input() totalItems = 0;
  @Input() showTotalItems = true;
  @Input() showTotalFilterAdvanced = false;
  @Input() filterCount = 0;
  @Input() backTo: string = "";
  @Input() translationKey: string = "";
  @Input() selectedTranslationModuleEnum: number;
  @Input() titleBtnTranslationKey: string = "";
  @Input() titleBtnTranslationModuleEnum: number;
  @Input() addBtnDisabled: boolean = false;
  @Input() higherLevel: boolean = false;

  @Output() btnClick: EventEmitter<void> = new EventEmitter();
  @Output() customBtnClick: EventEmitter<number> = new EventEmitter();
  @Output() search: EventEmitter<string> = new EventEmitter();
  @Output() onAdvancedFilter: EventEmitter<string> = new EventEmitter();

  constructor(
    private location: Location,
    private router: Router,
    private popupSer: PopupService
  ) {}

  ngOnInit(): void {}

  evnet() {
    this.btnClick.emit();
    event.preventDefault();
  }

  clickEvent(btnAction: number) {
    this.customBtnClick.emit(btnAction);
  }

  changeSearch(value: string) {
    this.search.emit(value);
  }

  back() {
    if (this.backTo.length > 0) {
      this.router.navigateByUrl(this.backTo);
    } else {
      this.location.back();
    }
  }

  advancedFilter() {
    this.onAdvancedFilter.emit();
  }

  closeAddPopup() {
    this.isOpenPopUp = false;
    this.popupSer.close();
  }
}
